import React, { useMemo } from "react";
import { useTrans } from "system/translations/hooks";
import { FormConfigType } from "../../services/formBuilder/types";
import DotsMenu from "components/atoms/DotsMenu";
import { useDefaultFieldsConfig } from "services/formBuilder/hooks";
import { CreateEditFormConfigParams } from "modules/roles/types";
import { css } from "@emotion/css";
import { TableColumnType } from "services/table/types";

export const useTableColumns = (): TableColumnType[] => {
  const { _t } = useTrans();
  const columns = useMemo(
    (): TableColumnType[] => [
      {
        Header: _t("name"),
        accessor: "name",
        id: "name",
        isMobileTitle: true,
      },
      {
        Header: _t("description"),
        accessor: "description",
        id: "description",
      },
      {
        maxWidth: 65,
        Header: "",
        id: "UpdateDeleteMenu",
        Cell: (props: any) => {
          return (
            <DotsMenu
              clickParams={{
                id: props?.row?.original?.id,
                allData: props?.row?.original,
              }}
              items={props?.actionMenuItems}
            />
          );
        },
      },
    ],
    []
  );

  return columns;
};

export const useCreateEditConfig = (
  params: CreateEditFormConfigParams
): FormConfigType => {
  const { _t } = useTrans();
  const fields = useDefaultFieldsConfig();
  const authorities = params?.rolesAuthorities?.map((item: any) =>
    fields.formFields.authority({
      name: `authorities.${item.name}`,
      componentProps: { title: item.name, description: item.description },
      columnParams: {
        className: css`
          margin: 0;
        `,
        lg: 6,
        md: 6,
      },
    })
  );
  const formConfig = useMemo((): FormConfigType => {
    return [
      fields.formFields.name(),
      fields.formFields.description(),
      ...authorities,
      fields.general.divider(),
      fields.general.saveBtn({
        componentProps: {
          kind: params.isEdit ? "primary" : "secondary",
          label: params.isEdit ? _t("save_changes") : _t("create_new_role"),
        },
      }),
    ];
  }, [authorities]);
  return formConfig;
};
